import 'video.js/dist/video-js.css';
import React, { useRef, useEffect, useState } from 'react';

import './Video.scss';
import { link } from '../../helpers/link';
import { convert } from '../../helpers/date';
import IconsBar from '../IconsBar/IconsBar.jsx';
import { getString } from '../../helpers/styles';
import CommentList from '../CommentList/CommentList.jsx';

import Subscribe from '../../shared/assets/icons/subscribe.svg';

export default function Video(props) {
  const {
    uri,
    user,
    title,
    config,
    channel,
    videoUrl,
    comments,
    postedAt,
    bookmarks,
    shareUrls,
    addBookmark,
    isSubscribed,
    isPreviewMode,
    removeBookmark,
    showLoginPopup,
    subscribeChannel,
    unsubscribeChannel
  } = props;

  const postedDate = convert(postedAt.replace(/-/g, '/'), 'en-US');

  const playerRef = useRef(null);
  const [fullDescription, showFullDescription] = useState(false);

  const [duration, setDuration] = useState(null);

  useEffect(async () => {
    const videojs = (await import('video.js')).default;

    const player = videojs(playerRef.current, {
      fluid: true,
      controls: true,
      sources: [{ src: videoUrl, type: 'video/mp4' }]
    });

    player.on('loadeddata', () => {
      const duration = player.duration();

      const seconds = Math.round(duration % 60);
      const minutes = parseInt(duration / 60, 10);

      setDuration(`${minutes}:${seconds < 10 ?
        `0${seconds}` : seconds}`);
    });
  }, [videoUrl]);

  return (
    <article className="video">
      <div>
        <div data-vjs-player>
          <video ref={playerRef} className="video-js" />
        </div>
      </div>

      <h1 className="video_title">{title}</h1>

      <div className="video_info">
        <span>{duration} minuten, geupload op {postedDate}</span>

        <IconsBar
          user={user}
          config={config}
          contentUri={uri}
          shareUrls={shareUrls}
          bookmarks={bookmarks}
          addBookmark={addBookmark}
          showLoginPopup={showLoginPopup}
          removeBookmark={removeBookmark}
        />
      </div>

      {channel && <div className="video_channel">
        <div>
          {link(<img src={channel.imageUrl} alt="channel-image" />,
            `/channels/${channel.uri}`)}

          <div className="video_channel_info">
            {link(<p>{channel.displayName}</p>, `/channels/${channel.uri}`)}

            <span>{channel.numberOfFollowers} volgers,
              {` ${channel.contentCount} videos`}
            </span>
          </div>

          <div className="video_subscribe_button">
            {isSubscribed ?
              <button
                className="video_button_unsubscribed"
                onClick={() => unsubscribe(channel)}>
                <Subscribe />Geabonneerd
              </button> :

              <button onClick={() => subscribe(channel)}>
                <Subscribe />Abonneer
              </button>
            }
          </div>
        </div>

        <p className={getString([{
          value: 'video_channel_description_short',
          condition: !fullDescription
        }, {
          value: 'video_channel_description',
          condition: true
        }])}>
          {channel.description}
        </p>

        {channel.description.length > 175 && !fullDescription &&
          <p onClick={() => showFullDescription(true)}>
            Laad meer...
          </p>
        }
      </div>}

      {!isPreviewMode && !!comments.length && <CommentList {...props} />}
    </article>
  );

  function subscribe(channel) {
    if (!user.username)
      return showLoginPopup('Log in om een kanaal te volgen');

    subscribeChannel({ variables: {
      channelUri: channel.uri
    } });
  }

  function unsubscribe(channel) {
    unsubscribeChannel({ variables: {
      channelUri: channel.uri
    } });
  }
}
